export default "__VITE_ASSET__YCM136cu__"